var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.selectedArea == null
      ? _c("div", { staticClass: "modal-card-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label", attrs: { for: "" } }, [
              _vm._v("Buscar area"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.areaInput,
                    expression: "areaInput",
                  },
                ],
                staticClass: "input",
                attrs: {
                  type: "text",
                  placeholder: "Escriba el nombre del area",
                },
                domProps: { value: _vm.areaInput },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.areaInput = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("p", [_vm._v(_vm._s(_vm.status))]),
            _vm._v(" "),
            _c(
              "table",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchResult.length > 0,
                    expression: "searchResult.length > 0",
                  },
                ],
                staticClass: "table is-bordered is-narrow is-marginless",
              },
              [
                _c(
                  "tbody",
                  _vm._l(_vm.searchResult, function (result) {
                    return _c("tr", { key: result.index }, [
                      _c("td", [
                        _c("i", { staticClass: "fas fa-tag" }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.selectArea(result)
                              },
                            },
                          },
                          [_vm._v(_vm._s(result.nombre))]
                        ),
                        _vm._v(" "),
                        _vm.tieneRolLyris
                          ? _c("span", { staticClass: "disabled" }, [
                              _vm._v(
                                "organizacion_id: " +
                                  _vm._s(result.organizacion_id)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            ),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "modal-card-body" },
          [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label", attrs: { for: "" } }, [
                _vm._v("Area"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  staticClass: "input is-static",
                  attrs: { type: "text", readonly: "" },
                  domProps: { value: _vm.selectedArea.nombre },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "b-field",
              { attrs: { label: "Seleccione el nivel de permiso" } },
              [
                _c(
                  "b-slider",
                  {
                    attrs: {
                      size: "",
                      min: 0,
                      max: 8,
                      ticks: "",
                      type: "is-success",
                      "custom-formatter": (val) => `Nivel ${val}`,
                      rounded: "",
                    },
                    model: {
                      value: _vm.selectedLevel,
                      callback: function ($$v) {
                        _vm.selectedLevel = $$v
                      },
                      expression: "selectedLevel",
                    },
                  },
                  [
                    _vm._l(9, function (v, i) {
                      return [
                        _c(
                          "b-slider-tick",
                          { key: `tick-${i}`, attrs: { value: i } },
                          [_vm._v(_vm._s(i))]
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("listado-permisos", { attrs: { level: _vm.selectedLevel } }),
          ],
          1
        ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-card-foot is-justify-content-flex-end" }, [
      _c(
        "button",
        {
          staticClass: "button is-outlined is-dark",
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("\n      Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button is-primary",
          attrs: { disabled: _vm.selectedArea == null },
          on: {
            click: function ($event) {
              return _vm.submit()
            },
          },
        },
        [_c("i", { staticClass: "fas fa-save fa-fw" }), _vm._v(" Guardar")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v("Asignar nuevo permiso (Area)"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }